const groupBy = (array, key) => {
  return array.reduce((groups, element) => {
    (groups[element[key]] = groups[element[key]] || []).push(element)
    return groups
  }, {})
}

export default groupBy
